
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { format } from 'date-fns';

@Component({
  components: { ValidationProvider },
})
export default class NewClaimYearSelector extends Vue {
  @Prop({ type: Array, default: [] })
  value!: Date[];

  @Prop({ type: Date, required: true })
  beginDate!: Date;

  @Prop({ type: Date, required: true })
  endDate!: Date;

  get getValue() {
    if (this.value && this.value.length) {
      return this.yearArray.find((year) => year.value[0] === this.value[0]).id;
    }
    return undefined;
  }

  get rules(): any {
    return this.$attrs.rules;
  }

  get yearArray(): any[] {
    const today = new Date(Date.now());

    // if the agreement is active, the end date is set as today so you can't claim in the future.
    // when the registration period is annual this means you cannot register for this year.
    const activeAgreement =
      format(new Date(this.endDate), 'yyyy-MM-dd') ===
      format(today, 'yyyy-MM-dd');

    const beginYear = new Date(this.beginDate).getFullYear();
    const endYear = new Date(this.endDate).getFullYear();

    const years = Array.from(
      { length: endYear - (activeAgreement ? 1 : 0) - beginYear + 1 },
      (_, index) => index + beginYear,
    );

    return years.map((year, index) => {
      const startDate =
        year === beginYear
          ? format(this.beginDate, 'yyyy-MM-dd')
          : `${year}-01-01`;
      const endDate =
        year === endYear ? format(this.endDate, 'yyyy-MM-dd') : `${year}-12-31`;

      return {
        id: index + 1,
        value: year,
        dates: [new Date(startDate), new Date(endDate)],
      };
    });
  }

  onInput(value: number) {
    const dates = this.yearArray.find((year) => year.id === value)?.dates;
    this.$emit('input', dates);
  }

  classNames(errors: any[]): any {
    return {
      'field--has-error': errors.length,
      'field--required': this.hasRule('required'),
    };
  }

  hasRule(rule: string): boolean {
    return this.rules && this.rules.includes(rule);
  }
}
